import React from "react";

const articles = [
  {
    cat: "Histoires de Makers",
    title: "De simples cartons à un robot mobile : l’aventure de Sarah et Kevin",
    resume: "Deux collégiens béninois racontent comment ils ont conçu leur premier robot avec des matériaux recyclés et un micro:bit.",
    tags: "#Makers #Robotique #Inspiration",
    img: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=800&q=80",
  },
  {
    cat: "Innovation & Éducation",
    title: "Pourquoi l’apprentissage par la pratique change la donne en Afrique",
    resume: "Un regard sur la pédagogie active et comment elle ouvre des perspectives inédites pour les jeunes apprenants.",
    tags: "#EdTech #Afrique #FutureOfLearning",
    img: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=800&q=80",
  },
  {
    cat: "Projets & Tutoriaux",
    title: "Fabriquer ta première borne d’arcade avec MakeCode",
    resume: "Un tutoriel pas à pas pour concevoir un mini-jeu et l’intégrer dans une borne d’arcade fabriquée collectivement.",
    tags: "#Coding #DIY #Arcade",
    img: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=800&q=80",
  },
  {
    cat: "Vie de la Communauté",
    title: "Retour sur le Summer Camp 2025 : 20 jeunes, 10 robots et des étoiles plein les yeux",
    resume: "Un récap en images et témoignages du stage d’été, avec focus sur les projets marquants.",
    tags: "#SummerCamp #Jeunesse #STEM",
    img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
  },
  {
    cat: "NextMaker Insights",
    title: "Du Fablab à la plateforme : la vision derrière NextMaker",
    resume: "L’équipe fondatrice partage l’histoire et la vision qui relient IrokoFabLab, le mouvement maker et la plateforme.",
    tags: "#Vision #NextMaker #Histoire",
    img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
  },
  {
    cat: "Innovation & Éducation",
    title: "Les 5 compétences essentielles pour les métiers de demain",
    resume: "Un article clair pour parents et jeunes sur les savoirs à développer : créativité, collaboration, pensée critique, numérique et autonomie.",
    tags: "#FuturDuTravail #Compétences #Education",
    img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
  },
];

const BlogList = ({ selected }) => {
  const filtered =
    selected === "Tous"
      ? articles
      : articles.filter((a) => a.cat === selected);

  return (
    <section className="w-full bg-light-5 py-12 px-6">
      <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {filtered.map((a, i) => (
          <div key={i} className="bg-white rounded-2xl overflow-hidden">
            <img src={a.img} alt={a.title} className="w-full h-48 object-cover" />
            <div className="p-5">
              <span className="text-xs text-blue-1 font-semibold uppercase">
                {a.cat}
              </span>
              <h4 className="font-bold text-dark-1 mt-2">{a.title}</h4>
              <p className="text-sm text-light-1 mt-2">{a.resume}</p>
              <p className="text-xs text-dark-3 mt-3">{a.tags}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogList;
